(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customers-activate-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const err = document.querySelector('[data-acct-error]');
    if (err) err.focus();
    const pw = document.getElementById('ActivatePassword');
    const cf = document.getElementById('ActivateConfirm');
    if (!pw || !cf) return;
    const check = () => {
      cf.setCustomValidity(cf.value && cf.value !== pw.value ? 'The two passwords do not match.' : '');
      cf.closest('.acct-field')?.classList.toggle('acct-field--invalid', Boolean(cf.validationMessage));
    };
    pw.addEventListener('input', check);
    cf.addEventListener('input', check);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-addresses]');
    if (!root) return;

    const setOpen = (btn, pane, open) => {
      pane.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        const first = pane.querySelector('input, select');
        if (first) first.focus();
      }
    };

    root.querySelectorAll('[data-address-toggle]').forEach((btn) => {
      const pane = document.getElementById(btn.dataset.addressToggle);
      if (!pane) return;
      btn.addEventListener('click', () => setOpen(btn, pane, pane.hidden));
    });

    root.querySelectorAll('[data-address-cancel]').forEach((btn) => {
      const pane = document.getElementById(btn.dataset.addressCancel);
      if (!pane) return;
      btn.addEventListener('click', () => {
        const toggle = root.querySelector(`[data-address-toggle="${btn.dataset.addressCancel}"]`);
        pane.hidden = true;
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
      });
    });

    // Deleting an address is destructive and irreversible — confirm first.
    root.querySelectorAll('[data-address-delete]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (!window.confirm(btn.dataset.confirm)) e.preventDefault();
      });
    });

    // Shopify's own country/province wiring: repopulate the province select
    // (and hide it entirely for countries that have none) whenever the
    // country changes.
    root.querySelectorAll('[data-country-select]').forEach((select) => {
      const wrap = document.getElementById(select.dataset.provinceWrap);
      const province = document.getElementById(select.dataset.provinceSelect);
      if (!wrap || !province) return;
      const sync = () => {
        const opt = select.options[select.selectedIndex];
        let list = [];
        try {
          list = JSON.parse(opt.getAttribute('data-provinces') || '[]');
        } catch (_) {
          list = [];
        }
        province.innerHTML = '';
        if (!list.length) {
          wrap.hidden = true;
          province.removeAttribute('required');
          return;
        }
        wrap.hidden = false;
        province.setAttribute('required', 'required');
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Select';
        placeholder.disabled = true;
        placeholder.selected = true;
        province.appendChild(placeholder);
        list.forEach(([value, label]) => {
          const o = document.createElement('option');
          o.value = value;
          o.textContent = label;
          if (value === province.dataset.selected) {
            o.selected = true;
            placeholder.selected = false;
          }
          province.appendChild(o);
        });
      };
      select.addEventListener('change', sync);
      sync();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-login"]) return;
  try {
    
  // Recover pane toggle. Progressive enhancement only: with no JS the pane is
  // still reachable (it is in the DOM, and Shopify reveals it after a post).
  document.addEventListener('DOMContentLoaded', () => {
    const pane = document.getElementById('AcctRecover');
    if (!pane) return;
    const open = document.querySelector('[data-acct-recover-open]');
    const close = document.querySelector('[data-acct-recover-close]');
    const focusFirst = () => {
      const f = pane.querySelector('input');
      if (f) f.focus();
    };
    if (open) {
      open.addEventListener('click', (e) => {
        e.preventDefault();
        pane.hidden = false;
        focusFirst();
      });
    }
    if (close) {
      close.addEventListener('click', () => {
        pane.hidden = true;
        const back = document.getElementById('AcctLoginEmail');
        if (back) back.focus();
      });
    }
    // The recover form posts back to this page — if it produced a result, the
    // pane must be open or the user sees nothing happen.
    if (pane.querySelector('[data-acct-recover-result]') || /recover/i.test(location.search + location.hash)) {
      pane.hidden = false;
      const result = pane.querySelector('[data-acct-recover-result]');
      if (result) {
        result.setAttribute('tabindex', '-1');
        result.focus();
      }
    }

    // surface a server-side error to assistive tech immediately
    const err = document.querySelector('[data-acct-error]');
    if (err) err.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-register"]) return;
  try {
    
  // Five-step trade application. Progressive enhancement: with JS off every
  // fieldset is visible (the [hidden] attributes are removed on init only when
  // JS runs, and the form posts in one go), so the application still works.
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-acct-panel="trade"]');
    if (!root) return;

    // ── mode switch ──
    document.querySelectorAll('[data-acct-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const want = btn.dataset.acctMode;
        document.querySelectorAll('[data-acct-mode]').forEach((b) =>
          b.setAttribute('aria-pressed', String(b.dataset.acctMode === want))
        );
        document.querySelectorAll('[data-acct-panel]').forEach((p) => {
          p.hidden = p.dataset.acctPanel !== want;
        });
      });
    });

    // ── steps ──
    const steps = [...root.querySelectorAll('[data-step]')];
    if (!steps.length) return;
    const chips = [...root.querySelectorAll('[data-step-chip]')];
    const prev = root.querySelector('[data-acct-prev]');
    const next = root.querySelector('[data-acct-next]');
    const submit = root.querySelector('[data-acct-submit]');
    const progress = root.querySelector('[data-acct-progress]');
    const review = root.querySelector('[data-acct-review]');
    let i = 0;

    const paint = () => {
      steps.forEach((s, n) => {
        s.hidden = n !== i;
      });
      chips.forEach((c, n) => {
        if (n === i) c.setAttribute('aria-current', 'step');
        else c.removeAttribute('aria-current');
        c.dataset.done = String(n < i);
      });
      if (prev) prev.hidden = i === 0;
      if (next) next.hidden = i === steps.length - 1;
      if (submit) submit.hidden = i !== steps.length - 1;
      if (progress) progress.textContent = `Step ${i + 1} of ${steps.length}`;
      const legend = steps[i].querySelector('legend');
      if (legend) {
        steps[i].setAttribute('tabindex', '-1');
        steps[i].focus({ preventScroll: false });
      }
    };

    // Validate only the fields in the CURRENT step — reportValidity on the
    // whole form would trip over the steps the user has not reached.
    const stepValid = () => {
      const fields = [...steps[i].querySelectorAll('input, select, textarea')];
      for (const f of fields) {
        f.closest('.acct-field')?.classList.remove('acct-field--invalid');
      }
      for (const f of fields) {
        if (!f.checkValidity()) {
          f.closest('.acct-field')?.classList.add('acct-field--invalid');
          f.reportValidity();
          f.focus();
          return false;
        }
      }
      return true;
    };

    const buildReview = () => {
      if (!review) return;
      const rows = [...root.querySelectorAll('[data-review]')]
        .filter((f) => f.value && f.value.trim())
        .map((f) => `<dt>${f.dataset.review}</dt><dd>${f.value.replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]))}</dd>`);
      review.innerHTML = rows.length ? rows.join('') : '<dt>Review</dt><dd>Nothing entered yet.</dd>';
    };

    next?.addEventListener('click', () => {
      if (!stepValid()) return;
      i = Math.min(i + 1, steps.length - 1);
      if (i === steps.length - 1) buildReview();
      paint();
    });
    prev?.addEventListener('click', () => {
      i = Math.max(i - 1, 0);
      paint();
    });

    paint();

    const flash = document.querySelector('[data-acct-success], [data-acct-error]');
    if (flash) flash.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-reset-password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const err = document.querySelector('[data-acct-error]');
    if (err) err.focus();
    const pw = document.getElementById('ResetPassword');
    const cf = document.getElementById('ResetConfirm');
    if (!pw || !cf) return;
    // Inline mismatch feedback, so the user is not told only after a round trip.
    const check = () => {
      cf.setCustomValidity(cf.value && cf.value !== pw.value ? 'The two passwords do not match.' : '');
      cf.closest('.acct-field')?.classList.toggle('acct-field--invalid', Boolean(cf.validationMessage));
    };
    pw.addEventListener('input', check);
    cf.addEventListener('input', check);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-article"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-project-back-top]');
    if (!link) return;
    event.preventDefault();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const lenis = window.DRMotion?.lenis;
    if (lenis && !reduced) lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-ymal-tab]');
    if (!tab) return;
    const root = tab.closest('.ymal');
    root.querySelectorAll('[data-ymal-tab]').forEach((t) => {
      const active = t === tab;
      t.setAttribute('aria-selected', String(active));
      t.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-ymal-panel]').forEach((p) => {
      p.hidden = p.dataset.ymalPanel !== tab.dataset.ymalTab;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      if (!this.grid) return;
      // Render whenever the store announces (boot + every toggle +
      // the Swym post-install migration).
      this.onChange = () => this.render();
      document.addEventListener('wishlist:change', this.onChange);
      if (window.DRWishlist) this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.onChange);
    }

    async render() {
      const items = window.DRWishlist ? window.DRWishlist.list() : [];
      const token = (this.renderToken = Symbol());
      if (!items.length) {
        this.grid.hidden = true;
        this.grid.innerHTML = '';
        this.empty.hidden = false;
        return;
      }
      this.empty.hidden = true;
      const cards = await Promise.all(
        items.map(async (item) => {
          try {
            const res = await fetch(`${window.Shopify?.routes?.root || '/'}products/${item.handle}?sections=wishlist-item`);
            if (!res.ok) return null;
            const data = await res.json();
            return data['wishlist-item'] || null;
          } catch (e) {
            return null; // deleted / drafted designs drop silently
          }
        })
      );
      if (this.renderToken !== token) return; // superseded by a newer render
      const html = cards
        .filter(Boolean)
        .map((card) => `<div class="listing-grid__cell">${card}</div>`)
        .join('');
      if (html) {
        this.grid.innerHTML = html;
        this.grid.hidden = false;
      } else {
        this.grid.hidden = true;
        this.empty.hidden = false;
      }
    }
  }
  if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);

  } catch(e) { console.error(e); }
})();
})();
